module.exports = __webpack_public_path__ + "static/media/agoraMuseum.59ef3931.png";